import { Props } from './Tag.model';

import styles from './Tag.module.scss';

const Tag = ({ className, color = 'grey', children, noBackground}: Props) => {
	const backgroundClass = noBackground? styles.noBackground : '';

	const classes = 'tag ' + className;

	return (
		<span className={`${classes} ${styles.tag} ${styles[color]} ${backgroundClass}`}>
			{children}
		</span>
	);
}

export default Tag;